export const Categories=[
    {
        id: 1,
        title: 'Education',
        icon: require("../Assests/graduation-cap.png"),
        color: "#38954F",
    },
    {
        id: 2,
        title: 'HealthCare',
        icon: require('../Assests/doctor.png'),
        color: "#ECA201",
    },
    {
        id: 3,
        title: 'Shopping',
        icon: require('../Assests/shopping-cart.png'),
        color: "#006371",
    },
    {
        id: 4,
        title: 'Food',
        icon: require('../Assests/hamburger.png'),
        color: "#FFECCB",
    },
    {
        id: 5,
        title: 'Others',
        icon: require('../Assests/search-alt.png'),
        color: "#C3FCF2",
    },
]